import { useSelector } from 'react-redux';

import { selectDictionary } from 'features/dictionaries/dictionariesSelectors';

import { isNil } from 'utils/isNil';

import { Dictionaries } from 'constants/enums';
import { FALLBACK_VALUE } from 'constants/uiSettings';

interface SalaryProps {
  actualSalary: string | null;
  payrollRates: string | null;
}

const Salary = ({ actualSalary, payrollRates }: SalaryProps) => {
  const payrollRatesDict = useSelector(
    selectDictionary(Dictionaries.PayrollRates)
  );

  const rate =
    !isNil(payrollRates) && payrollRatesDict.length
      ? (payrollRatesDict.find((rate) => rate.value === payrollRates)
          ?.label as string)
      : '';

  if (isNil(actualSalary)) {
    return <div>{FALLBACK_VALUE}</div>;
  }

  return (
    <div>{`${actualSalary} ${rate.charAt(0).toLowerCase() + rate.slice(1)}`}</div>
  );
};

export default Salary;
